<template>
  <Form @submit="onSubmit">
    <div class="tp-login-input-wrapper">
      <div class="tp-login-input-box">
        <div class="tp-login-input">
          <Field
            type="email"
            name="email"
            placeholder="swift@mail.com"
            rules="required"
            v-model="_form.email"
          />
        </div>
        <div class="tp-login-input-title">
          <label for="email">{{ $t("Email") }}</label>
        </div>
        <error-message name="email" class="text-danger text-xs" />
      </div>
      <div class="tp-login-input-box">
        <div class="p-relative">
          <div class="tp-login-input">
            <Field
              :type="showPass ? 'text' : 'password'"
              name="password"
              placeholder="Min. 6 character"
              :rules="{
                required,
                min: 6,
              }"
              v-model="_form.password"
            />
          </div>
          <div class="tp-login-input-eye" id="password-show-toggle">
            <span class="open-eye" @click="togglePasswordVisibility">
              <template v-if="showPass">
                <svg-open-eye />
              </template>
              <template v-else>
                <svg-close-eye />
              </template>
            </span>
          </div>
          <div class="tp-login-input-title">
            <label for="tp_password">{{ $t("Password") }}</label>
          </div>
        </div>
        <error-message name="password" class="text-danger text-xs" />
      </div>
    </div>
    <div
      class="tp-login-suggetions d-sm-flex align-items-center justify-content-between mb-20"
    >
      <!-- <div class="tp-login-remeber">
        <input id="remeber" type="checkbox" />
        <label for="remeber">Remember me</label>
      </div> -->
      <div class="tp-login-forgot">
        <nuxt-link-locale href="/forgot">{{
          $t("Forgot Password?")
        }}</nuxt-link-locale>
      </div>
    </div>
    <div class="tp-login-bottom">
      <button type="submit" class="tp-login-btn w-100" :disabled="loading">
        <template v-if="loading">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading...
        </template>
        <template v-else>
          {{ $t("login") }}
        </template>
      </button>
    </div>
  </Form>
</template>

<script setup lang="ts">
import { useAuthStore } from "@/pinia/useAuthStore";
import { Form, Field, ErrorMessage, defineRule } from "vee-validate";
import { required, email, min } from "@vee-validate/rules";
import { handleValidationMessages } from "../../helpers/rules";
import { useCartStore } from "../../pinia/useCartStore";
import { storeToRefs } from "pinia";
const { signIn } = useAuthStore();
const { cartID } = storeToRefs(useCartStore());
const _form = reactive({
  email: "moo@moo.com",
  password: "Mo@swift1",
  cart_id: cartID.value,
});
// validation

defineRule("required", required);
defineRule("email", email);
defineRule("min", min);
handleValidationMessages();

let showPass = ref<boolean>(false);
const loading = ref(false);

const onSubmit = async (values) => {
  loading.value = true;
  await signIn(_form);
  loading.value = false;
  // resetForm();
};

const togglePasswordVisibility = () => {
  showPass.value = !showPass.value;
};
</script>
